<script>
import { mapGetters, mapState } from 'vuex';

import { capitalizeFirstLetter, formatAmount } from '../lib/formatters';

export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      scope: {
        scope: 'pay.js.marketing.summary'
      }
    };
  },

  computed: {
    ...mapState([
      'productRecurrence'
    ]),

    ...mapState({
      focusOnPriceExVat: (state) => state.product.focusOnPriceExVat
    }),

    ...mapGetters([
      'hasDifferentPriceForFirstPeriod',
      'hasDifferentLengthForFirstPeriod',
      'hasTrial',
      'totalRecurrenceDiscountedAmount'
    ]),

    formattedTotalDiscountedAmount() {
      return formatAmount(this.totalRecurrenceDiscountedAmount, true);
    },

    capitalizedRecurrenceMessagePeriod() {
      return capitalizeFirstLetter(this.recurrenceMessagePeriod);
    },

    recurrenceMessagePeriod() {
      if (this.productRecurrence.isOnDemand) {
        return this.t('recurrence_message.first_payment', this.scope);
      }

      let periodTerm;

      if (this.productRecurrence.isSubscription) {
        let period;

        if (this.hasTrial) {
          periodTerm = this.firstPeriodMessage;
        } else {
          periodTerm = this.t('recurrence_message.per', this.scope);
        }

        if (this.hasDifferentLengthForFirstPeriod) {
          period = this.productRecurrence.period1;
        } else {
          period = this.productRecurrence.period;
        }

        return `${periodTerm} ${period}`;
      }

      if (this.hasDifferentPriceForFirstPeriod) {
        periodTerm = this.t('recurrence_message.first', this.scope);
      } else {
        periodTerm = this.t('recurrence_message.per', this.scope);
      }

      return `${periodTerm} ${this.t('recurrence_message.installment', this.scope)}`;
    },

    recurrenceMessageVat() {
      return this.focusOnPriceExVat ? this.t('ex_vat', this.scope) : this.t('inc_vat', this.scope);
    },

    showRecurrenceMessageDetail() {
      return this.type === 'detail' && this.hasTrial && !this.productRecurrence.isOnDemand;
    },

    isShortMessage() {
      return this.type === 'short';
    },

    firstPeriodMessage() {
      const { periodsType, periodsMultiplier } = this.productRecurrence;

      return this.t(`recurrence_message.first_period.${periodsType}`, {
        ...this.scope,
        count: periodsMultiplier
      });
    }
  }
};
</script>

<template>
  <small v-if="isShortMessage">
    {{ capitalizedRecurrenceMessagePeriod }}
  </small>

  <div v-else-if="showRecurrenceMessageDetail">
    <small v-if="productRecurrence.isSubscription">
      {{
        t('recurrence_message.subscription_message', {
          ...scope,
          amount: formattedTotalDiscountedAmount,
          vat_text: recurrenceMessageVat,
          per: t('recurrence_message.per', scope),
          period: productRecurrence.period
        })
      }}
    </small>

    <small v-else>
      {{
        t('recurrence_message.installments_message', {
          ...scope,
          num_installments_text: t('recurrence_message.installments', {
            ...scope,
            count: productRecurrence.quantity - 1
          }),
          amount: formattedTotalDiscountedAmount,
          vat_text: recurrenceMessageVat,
        })
      }}
    </small>
  </div>
</template>
